export async function setCity(setURL, cityData, callback) {
    const hasCallback = typeof callback === 'function';
    const forceReload = !hasCallback;
    const request = makeSetCityRequest(setURL, cityData, forceReload);

    if (hasCallback)
        request.then(() => callback(cityData));

    return request;
}

async function makeSetCityRequest(setURL, cityData, forceReload = true) {
    const {default: axios} = await import('axios');

    const request = axios.post(setURL, new URLSearchParams(cityData).toString());

    if (forceReload)
        request.then(() => window.location.reload());

    return request;
}
